import {
  Controller,
  type FieldPath,
  type FieldValues,
  useFormContext,
} from "react-hook-form";
import React from "react";

import { SelectV2 } from "src/components/SelectV2/SelectV2.tsx";

import {
  useSingleSelectField,
  type UseSingleSelectFieldProps,
} from "src/components/Form/fields/hooks/useSingleSelectField.tsx";
import { composeRefs } from "@exonn/hooks";

export type SingleSelectFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = UseSingleSelectFieldProps<TFieldValues, TName>;
// todo: forward ref
export const SingleSelectField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: SingleSelectFieldProps<TFieldValues, TName>,
) => {
  const { name } = props;
  const form = useFormContext();
  const { getSelectProps } = useSingleSelectField<TFieldValues, TName>(props);

  return (
    <Controller
      key={name}
      name={name}
      control={form.control}
      render={(params) => {
        const {
          field: { ref },
        } = params;
        return <SelectV2 {...getSelectProps(params)} ref={composeRefs(ref)} />;
      }}
    />
  );
};
